<script setup lang="ts">
/**
 * Filter / sort chip — a pill trigger that opens a filter menu. Single-root <button> so the
 * @click(.stop) and aria fall through; content (label + chevron) via the default slot.
 * `variant`: floating (over the map, h-10) | panel (in a sidebar). `active` = a filter is applied.
 */
interface Props {
  active?: boolean
  variant?: 'floating' | 'panel'
  disabled?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  active: false,
  variant: 'panel',
  disabled: false,
})
</script>

<template>
  <button
    type="button"
    :disabled="props.disabled"
    class="inline-flex items-center gap-1 whitespace-nowrap rounded-full border bg-white/92 text-sm font-normal backdrop-blur-sm transition-colors disabled:cursor-default disabled:opacity-50 disabled:hover:bg-white/92"
    :class="[
      props.variant === 'floating' ? 'h-10 px-4 shadow-md' : 'px-4 py-1.5 shadow-sm',
      props.active
        ? 'border-gray-900/70 text-gray-900 hover:bg-white'
        : 'border-black/8 text-gray-600 hover:bg-white hover:text-gray-900',
    ]"
  >
    <slot />
  </button>
</template>
